<script>
export default {
  name: "ReportGPSHyperLink",
  functional: true,
  props: {
    row: Object,
    column: String,
    mes: Number,
    openDetail: Function
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = Number(context.props.row[col]);
    let Clases = "";

    switch (col) {
      case "offline":
        Clases = "red bold";
        break;
      case "idle":
        Clases = "yellow bold";
        break;
      case "active":
        Clases = "green bold";
        break;
      case "total_gps":
        Clases = "blue bold";
        break;
      case "signal_lost":
        Clases = "gray bold";
        break;
    }

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: Clases
        },
        on: {
          click: () => {
            const { row, openDetail } = context.props;
            openDetail(row, col);
          }
        }
      },
      val > 0 ? val : ""
    );
  }
};
</script>
<style scoped>
.bold {
  font-weight: bold;
  font-size: 17px;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
.yellow {
  color: orange;
}
.green {
  color: green;
}
.gray {
  color: gray;
}
</style>
